import { render, staticRenderFns } from "./salesByProductPieChart.vue?vue&type=template&id=df09128a&scoped=true"
import script from "./salesByProductPieChart.vue?vue&type=script&lang=js"
export * from "./salesByProductPieChart.vue?vue&type=script&lang=js"
import style0 from "./salesByProductPieChart.vue?vue&type=style&index=0&id=df09128a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df09128a",
  null
  
)

export default component.exports